import React from "react"
//import { Link } from "gatsby"

import Layout from "../components/layout"
//import Image from "../components/image"
import SEO from "../components/seo"

import Hero from "../components/hero/hero"
import SubHead from "../components/sub-head/sub-head"
import HomeIntro from "../components/home-intro/home-intro"

import "../styles/styles.scss"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <Hero />
    <SubHead />
    <HomeIntro />
  </Layout>
)

export default IndexPage
